export default {
  SET_VIEWER: 'HOME/SET_VIEWER',
  SET_ENTITIES: 'HOME/SET_ENTITIES',

  SET_LAYERS: 'LAYER/SET_LAYERS',
  SET_TREE_DATA: 'LAYER/SET_TREE_DATA',
  SET_CHECKED_KEYS: 'LAYER/SET_CHECKED_KEYS',

  SHOW_LABEL_MODAL: 'MARKER/SHOW_LABEL_MODAL',
  SET_MARKER_ENTITIES: 'MARKER/SET_MARKER_ENTITIES',
  SET_MARKER_LIST: 'MARKER/SET_MARKER_LIST',
  SET_MARKER_LIST_LOADING: 'MARKER/SET_MARKER_LIST_LOADING',
  SET_MARKER_LIST_PAGE: 'MARKER/SET_MARKER_LIST_PAGE',
  SET_MARKER_LIST_PAGE_SIZE: 'MARKER/SET_MARKER_LIST_PAGE_SIZE',
  SET_MARKER_LIST_KEYWORD: 'MARKER/SET_MARKER_LIST_KEYWORD',
  SET_MARKER_LIST_START_TIME: 'MARKER/SET_MARKER_LIST_START_TIME',
  SET_MARKER_LIST_END_TIME: 'MARKER/SET_MARKER_LIST_END_TIME', 
  SET_MARKER_REPORT: 'MARKER/SET_MARKER_REPORT', 
  SET_MARKER_CURRENT: 'MARKER/SET_MARKER_CURRENT', 
  SET_MARKER_CHECKEDS: 'MARKER/SET_MARKER_CHECKEDS', 
  SHOW_STANDING_BOOK: 'MARKER/SHOW_STANDING_BOOK', 
  SHOW_STANDING_BOOK_ADD: 'MARKER/SHOW_STANDING_BOOK_ADD',

  SET_UAV_TRACK: 'UAV/SET_UAV_TRACK', 
  SET_VIDEO_LIST: 'UAV/SET_VIDEO_LIST', 

  SET_LOGOUT_MODAL: 'LOGOUT_MODAL/SET_LOGOUT_MODAL',

  SET_ORIGIN_MODAL: 'TOOL_BAR/SET_ORIGIN_MODAL',
  SET_POSITION_MODAL: 'TOOL_BAR/SET_POSITION_MODAL',
  SET_MEASURE_VOLUME_MODAL: 'TOOL_BAR/SET_MEASURE_VOLUME_MODAL',

  START_SET_GRID_INFO: 'GRID/START_SET_GRID_INFO',
  SET_GRID_INFO: 'GRID/SET_GRID_INFO',
  END_SET_GRID_INFO: 'GRID/END_SET_GRID_INFO',
  
  SET_GRID_USER_MODAL: 'GRID/SET_GRID_USER_MODAL',
  SET_CALENDAR_MODAL: 'GRID/SET_CALENDAR_MODAL',
  SET_USER_WARNING_MODAL: 'GRID/SET_USER_WARNING_MODAL',
  SET_GRID_WARNING_MODAL: 'GRID/SET_GRID_WARNING_MODAL',
}